export default {
      id: "unit_dashboard__speed-usage",
      viewBox: "0 0 37 32",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__speed",
      toString: function () {
        return this.url;
      }
    }